module.exports = __webpack_public_path__ + "static/media/infrared-waves.f3485b81.svg";